import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
`;

export const Label = styled.label`
  margin-bottom: 10px;
  font-weight: bold;
`;

export const Input = styled.input`
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.span`
  margin-right: 5px;
`;

export const Result = styled.div`
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #b9ecff;
  background-color: #43cbff;
//   color: #fff
//   background-color: #f5f5f5;
`;
